/* ── Collection Release Date — filters + prev/next navigation ── */
(function () {
  'use strict';

  var CRD = window.CRD || {};
  var STOREFRONT_TOKEN = CRD.storefrontToken || '';
  var STOREFRONT_URL = window.Shopify
    ? 'https://' + window.Shopify.shop + '/api/2024-01/graphql.json'
    : '/api/2024-01/graphql.json';

  // ── DOM refs ────────────────────────────────────────────────────────────────
  var elGrid, elEmpty, elCount, elPubSelect, elSortSelect, elPrev, elNext;

  // ── Build collection URL preserving current filter params ───────────────────
  function buildCollectionUrl(overrides) {
    var handle = CRD.collectionHandle || '';
    var url    = new URL('/collections/' + handle, window.location.origin);
    var cur    = new URL(window.location.href);
    var carry  = ['sort_by', 'filter.p.tag', 'filter.p.vendor'];
    carry.forEach(function (key) {
      var val = (key in overrides) ? overrides[key] : cur.searchParams.get(key);
      if (val) url.searchParams.set(key, val);
    });
    return url.toString();
  }

  // ── Publisher dropdown ──────────────────────────────────────────────────────
  function buildPublisherDropdown() {
    var vendors      = CRD.vendors || [];
    var activeVendor = CRD.activeVendor ||
                       new URL(window.location.href).searchParams.get('filter.p.vendor') || '';
    var html = '<option value="">All Publishers</option>';
    vendors.sort().forEach(function (v) {
      html += '<option value="' + v.replace(/"/g, '&quot;') + '"' +
              (activeVendor === v ? ' selected' : '') + '>' +
              v.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</option>';
    });
    elPubSelect.innerHTML = html;
  }

  // ── Count display ───────────────────────────────────────────────────────────
  function updateCount() {
    var total = typeof window.CC_FILTERED_TOTAL === 'number'
      ? window.CC_FILTERED_TOTAL
      : (typeof window.CC_TOTAL === 'number' ? window.CC_TOTAL : 0);
    elCount.textContent = total + ' products';
  }

  // ── Navigate ────────────────────────────────────────────────────────────────
  function navigate(dest) {
    if (elGrid) elGrid.classList.add('cc-loading');
    window.location.href = dest;
  }

  function handleTypePillClick(tagValue, clickedBtn) {
    document.querySelectorAll('.cc-type-pill').forEach(function (btn) {
      btn.classList.toggle('cc-type-pill--active', btn === clickedBtn);
    });
    navigate(buildCollectionUrl({
      'filter.p.tag':    tagValue && tagValue !== 'all' ? tagValue : '',
      'filter.p.vendor': new URL(window.location.href).searchParams.get('filter.p.vendor') || '',
      'page':            ''
    }));
  }

  function handlePublisherChange(val) {
    navigate(buildCollectionUrl({ 'filter.p.vendor': val, 'page': '' }));
  }

  function handleSortChange(val) {
    var url = new URL(window.location.href);
    if (val) { url.searchParams.set('sort_by', val); }
    else      { url.searchParams.delete('sort_by'); }
    url.searchParams.delete('page');
    navigate(url.toString());
  }

  // ── Storefront API ──────────────────────────────────────────────────────────
  function storefrontQuery(query, variables) {
    return fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  var NAV_QUERY = '\
    query GetReleaseCollections($cursor: String) {\
      collections(first: 250, after: $cursor, query: "title:*Releases") {\
        pageInfo { hasNextPage endCursor }\
        edges { node { title handle } }\
      }\
    }';

  function fetchAllReleaseCollections() {
    var all = [];
    function fetchPage(cursor) {
      return storefrontQuery(NAV_QUERY, cursor ? { cursor: cursor } : {})
        .then(function (resp) {
          var data = resp && resp.data && resp.data.collections;
          if (!data) return all;
          (data.edges || []).forEach(function (e) { all.push(e.node); });
          if (data.pageInfo.hasNextPage) return fetchPage(data.pageInfo.endCursor);
          return all;
        });
    }
    return fetchPage(null);
  }

  // ── Parse "April 9, 2026 Releases" → Date ───────────────────────────────────
  function parseTitleDate(title) {
    var m = title.match(/^([A-Za-z]+)\s+(\d+),\s+(\d{4})\s+Releases$/);
    if (!m) return null;
    var months = { January:0, February:1, March:2, April:3, May:4, June:5,
                   July:6, August:7, September:8, October:9, November:10, December:11 };
    var mo = months[m[1]];
    if (mo === undefined) return null;
    return new Date(parseInt(m[3], 10), mo, parseInt(m[2], 10));
  }

  // ── Hydrate prev/next navigation arrows ─────────────────────────────────────
  function initNav() {
    if (!STOREFRONT_TOKEN || !elPrev || !elNext) return;
    var handle = CRD.collectionHandle || '';
    fetchAllReleaseCollections()
      .then(function (collections) {
        // Include all parseable-date collections; sort ascending (oldest → newest)
        var sorted = collections
          .filter(function (c) { return parseTitleDate(c.title) !== null; })
          .sort(function (a, b) {
            return parseTitleDate(a.title) - parseTitleDate(b.title);
          });

        var idx = -1;
        for (var i = 0; i < sorted.length; i++) {
          if (sorted[i].handle === handle) { idx = i; break; }
        }
        if (idx === -1) return; // current not in list — leave arrows hidden

        if (idx > 0) {
          var prev = sorted[idx - 1];
          elPrev.href = '/collections/' + prev.handle;
          elPrev.setAttribute('title', prev.title);
          elPrev.style.visibility = 'visible';
        }
        if (idx < sorted.length - 1) {
          var next = sorted[idx + 1];
          elNext.href = '/collections/' + next.handle;
          elNext.setAttribute('title', next.title);
          elNext.style.visibility = 'visible';
        }
      })
      .catch(function (e) {
        console.warn('[CRD] Nav fetch error:', e);
      });
  }

  // ── Init ────────────────────────────────────────────────────────────────────
  function init() {
    elGrid       = document.getElementById('cc-product-grid');
    elEmpty      = document.getElementById('cc-empty');
    elCount      = document.getElementById('cc-count');
    elPubSelect  = document.getElementById('cc-pub-select');
    elSortSelect = document.getElementById('cc-sort-select');
    elPrev       = document.getElementById('crd-prev');
    elNext       = document.getElementById('crd-next');

    if (!elGrid) return;

    var allItems = elGrid.querySelectorAll('.cc-item');
    if (elEmpty) elEmpty.style.display = allItems.length === 0 ? '' : 'none';

    buildPublisherDropdown();
    updateCount();

    // Sync pill active state from URL
    var urlTag = new URL(window.location.href).searchParams.get('filter.p.tag') || '';
    document.querySelectorAll('.cc-type-pill').forEach(function (btn) {
      var shouldBeActive = urlTag ? btn.dataset.type === urlTag : btn.dataset.type === 'all';
      btn.classList.toggle('cc-type-pill--active', shouldBeActive);
    });

    document.querySelectorAll('.cc-type-pill').forEach(function (btn) {
      btn.addEventListener('click', function () { handleTypePillClick(btn.dataset.type, btn); });
    });
    elPubSelect.addEventListener('change', function () { handlePublisherChange(this.value); });
    elSortSelect.addEventListener('change', function () { handleSortChange(this.value); });

    initNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
